// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2ZUKy","large":"styles_large__375ts"};